import createAxios from './axiosHttp';

function getManifestos(pagination,filters) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest`;
    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    if (filters && filters.sort) {
        if(filters.sort.sort){
            urlPath += `&sort=${filters.sort.sort}`;
        }
        if(filters.sort.order){
            urlPath += `&order=${filters.sort.order}`;
        }
    }
    return axios.get(urlPath);
}

function getManifest(manifestoId){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest/${manifestoId}`;
    return axios.get(urlPath);
}

function newManifest(body){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest`;
    return axios.post(urlPath, body);
}

function updateManifest(payload, entityId){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest/${entityId}`;
    return axios.put(urlPath, payload);
}

function deleteManifest(entityId) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest/${entityId}`;
    return axios.delete(urlPath);
}

function getManifestosAsExcel(filters, language) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest/${language}/report`;
    urlPath += `?page=0&limit=1000000`;
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}

function uploadResource(entityId, dataForm) {
    const axios = createAxios();
    let config = {header : {'Content-Type' : 'multipart/form-data'}}
    const user= JSON.parse(localStorage.getItem("user"));
    const url = `customer/${user.extraData.customerId}/manifest/${entityId}/resource`

    return axios.post(url, dataForm, config)
}


function downloadResource(entityId, fileName){
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest/${entityId}/resource?filename=${fileName}`;
    return axios.get(urlPath, {
        responseType: 'blob'
    });
}

function getResources(entityId) {
    const axios = createAxios();
    const user = JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest/${entityId}/resources`;
    return axios.get(urlPath);
}

function deleteResource(entityId, fileName) {
    const axios = createAxios();
    const user= JSON.parse(localStorage.getItem("user"));
    let urlPath = `customer/${user.extraData.customerId}/manifest/${entityId}/resource?filename=${fileName}`;
    return axios.delete(urlPath);
}

export const manifestService = {
    getManifestos,
    getManifest,
    newManifest,
    updateManifest,
    deleteManifest,
    getManifestosAsExcel,
    uploadResource,
    getResources,
    downloadResource,
    deleteResource,
};